export default __webpack_public_path__ + "end-device-placeholder.0779507e1efe772883413b3e22245b95.svg";